import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaFileExcel } from 'react-icons/fa';
import exportToExcel from './ExportToExcel';

const ExcelExportButton = ({
  fileName = 'export.xlsx',
  onBeforeExport,
  columns = null
}) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      let data = [];

      if (onBeforeExport && typeof onBeforeExport === 'function') {
        data = await onBeforeExport();
      }

      if (!data || data.length === 0) {
        alert('No data available to export.');
        setLoading(false);
        return;
      }

      exportToExcel(data, fileName, columns);
    } catch (error) {
      console.error('Export failed:', error);
      alert('Failed to export data.');
    }
    setLoading(false);
  };

  return (
    <Button variant="success" size="sm" onClick={handleExport} disabled={loading}>
      <FaFileExcel /> {loading ? 'Exporting...' : 'Export to Excel'}
    </Button>
  );
};

export default ExcelExportButton;
